import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  DxSelectBoxModule,
  DxDropDownButtonModule,
  DxDropDownBoxModule,
  DxButtonModule,
  DxFormModule,
  DxDataGridModule,
  DxTextBoxModule,
  DxAccordionModule,
  DxPopupModule,
  DxFileUploaderModule,
  DxTreeViewModule,
  DxNumberBoxModule,
  DxDateBoxModule,
  DxToastModule,
  DxPopoverModule,
  DxDrawerModule,
  DxMenuModule,
  DxLoadPanelModule,
  DxLoadIndicatorModule,
  DxScrollViewModule,
  DxToolbarModule
} from 'devextreme-angular';
import { RouterModule } from '@angular/router';
import { PSRReviewPopup } from './common-components/psr-review-popup/psr-review-popup';
import { ExcelToDxDataGrid } from './common-components/excel-to-dx-data-grid/excel-to-dx-data-grid';
import { DistributionWizard } from './common-components/distribution-wizard/distribution-wizard';
import { DistributionGrid } from './common-components/distribution-grid/distribution-grid';
import { NegativeToBracket } from './pipes/negativeToBracket.pipe';
import { ConfirmationPopupComponent } from './common-components/confirmation-popup/confirmation-popup.component';
import { LoadPanelComponent } from './common-components/load-panel/load-panel.component';
import { PdfPreviewPopupComponent } from './common-components/pdf-preview-popup/pdf-preview-popup.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PositiveToBracket } from './pipes/positiveToBracket.pipe';
import { PreviewPdfComponent } from './common-components/preview-pdf/preview-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({ declarations: [
        PSRReviewPopup,
        ExcelToDxDataGrid,
        DistributionWizard,
        DistributionGrid,
        NegativeToBracket,
        PositiveToBracket,
        ConfirmationPopupComponent,
        LoadPanelComponent,
        PdfPreviewPopupComponent,
        PreviewPdfComponent,
    ],
    exports: [
        PSRReviewPopup,
        ExcelToDxDataGrid,
        DistributionWizard,
        DistributionGrid,
        NegativeToBracket,
        PositiveToBracket,
        DxMenuModule,
        DxDrawerModule,
        ConfirmationPopupComponent,
        LoadPanelComponent,
        PdfPreviewPopupComponent,
        PreviewPdfComponent
    ], imports: [CommonModule,
        CommonModule,
        RouterModule,
        DxSelectBoxModule,
        DxDropDownButtonModule,
        DxDropDownBoxModule,
        DxButtonModule,
        DxAccordionModule,
        DxFormModule,
        DxDataGridModule,
        DxTextBoxModule,
        DxPopupModule,
        DxFileUploaderModule,
        DxTreeViewModule,
        DxNumberBoxModule,
        DxDateBoxModule,
        DxToastModule,
        DxPopoverModule,
        DxMenuModule,
        DxDrawerModule,
        DxLoadPanelModule,
        NgxExtendedPdfViewerModule,
        DxLoadIndicatorModule,
        DxScrollViewModule,
        PdfViewerModule,
        DxToolbarModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
